var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 36,
    viewBox: "0 0 89 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 3,
    width: 47,
    height: 30,
    rx: 12,
    fill: "#26365F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 1.5,
    width: 50,
    height: 33,
    rx: 13.5,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4144 8.76721L57.982 9.58185L54.6787 20.1722L59.2207 27.5039L65.4144 27.0966L71.1951 22.2088L65.4144 8.76721Z",
    fill: "#FF5C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9363 8.96212C59.7274 10.7932 57.5684 14.2157 57.5684 18.1357C57.5684 22.0557 59.7274 25.4782 62.9363 27.3093C61.3573 28.2103 59.524 28.726 57.5687 28.726C51.6395 28.726 46.833 23.9846 46.833 18.1357C46.833 12.2869 51.6395 7.54541 57.5687 7.54541C59.524 7.54541 61.3573 8.06109 62.9363 8.96212Z",
    fill: "#FC0101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5239 8.96212C65.7328 10.7932 67.8918 14.2157 67.8918 18.1357C67.8918 22.0557 65.7328 25.4782 62.5239 27.3093C64.1029 28.2103 65.9362 28.726 67.8915 28.726C73.8207 28.726 78.6272 23.9846 78.6272 18.1357C78.6272 12.2869 73.8207 7.54541 67.8915 7.54541C65.9362 7.54541 64.1029 8.06109 62.5239 8.96212Z",
    fill: "#FCD401"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 47,
    height: 30,
    rx: 12,
    fill: "#2666AC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 50,
    height: 33,
    rx: 13.5,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8423 12.3283H12.8011L14.7091 20.0328L18.837 12.3283H20.9916L15.2822 23H13.4903L10.8423 12.3283ZM22.341 12.3283H24.2998L22.8271 23H20.9046L22.341 12.3283ZM32.0261 13.8155L30.5679 15.1069C29.9681 14.333 29.4095 13.9461 28.892 13.9461C28.6357 13.9461 28.4229 14.0235 28.2536 14.1783C28.0843 14.3282 27.9997 14.5096 27.9997 14.7224C27.9997 14.9207 28.0771 15.1407 28.2319 15.3826C28.3866 15.6244 28.8558 16.1588 29.6393 16.9858C30.0552 17.426 30.3285 17.7379 30.459 17.9217C30.7734 18.3473 30.9983 18.7463 31.1337 19.1187C31.274 19.4863 31.3441 19.8611 31.3441 20.2432C31.3441 21.0993 31.0394 21.8175 30.43 22.3979C29.8206 22.9782 29.0395 23.2684 28.0868 23.2684C26.6358 23.2684 25.4533 22.5792 24.5392 21.2008L26.0772 19.9603C26.6963 20.9034 27.3661 21.3749 28.0868 21.3749C28.4301 21.3749 28.7179 21.2637 28.9501 21.0412C29.1871 20.8187 29.3056 20.5503 29.3056 20.236C29.3056 19.9893 29.233 19.7378 29.0879 19.4815C28.9477 19.2251 28.5414 18.7415 27.8691 18.0305C27.1582 17.2809 26.6914 16.715 26.469 16.3329C26.1691 15.8154 26.0192 15.3076 26.0192 14.8094C26.0192 14.1517 26.2344 13.5616 26.6648 13.0393C27.2065 12.3864 27.9368 12.0599 28.8558 12.0599C30.1181 12.0599 31.1748 12.6451 32.0261 13.8155ZM37.9677 12.3283H39.658L42.3133 23H40.369L39.8031 20.7293H35.5881L34.3621 23H32.2074L37.9677 12.3283ZM39.3171 18.843L38.461 15.339L36.582 18.843H39.3171Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44263 11.9313H12.7416L13.4328 14.6586L7.44263 11.9313Z",
    fill: "#EEA84D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.ad77648e586055e34b8da092be8df919.svg";
export { ForwardRef as ReactComponent };